<form #form="ngForm" class="app-grid">
    <ng-container *ngIf="benefit">
        <div class="columns-6 app-grid">
            @if (!hrBenefitMode) {
                <mat-form-field>
                    <mat-label appRemoveAriaOwns>{{
                        'payroll.benefits.benefitType' | translate | i18nLabel
                    }}</mat-label>
                    <mat-select
                        required
                        name="benefitTypeId"
                        #benefitTypeId="ngModel"
                        [(ngModel)]="benefit.benefitTypeId"
                        (ngModelChange)="benefitTypeChange.emit($event)"
                        [disabled]="benefit.id"
                        placeholder="{{ 'payroll.benefits.typePlaceholder' | translate }}"
                    >
                        <mat-option *ngFor="let type of benefitTypes" [value]="type.id">{{
                            type.displayName
                        }}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="benefitTypeId.invalid">{{ benefitTypeId.errors | formErrors }}</mat-error>
                </mat-form-field>
            }

            <mat-form-field *ngIf="hasBenefitsPayroll">
                <mat-label>{{ 'payroll.benefits.frequency' | translate }}</mat-label>
                <mat-select
                    name="benefitDeductionFrequencyUuid"
                    #benefitDeductionFrequencyUuid="ngModel"
                    [(ngModel)]="benefit.benefitDeductionFrequencyUuid"
                    required
                    placeholder="{{ 'payroll.benefits.frequencyPlaceholder' | translate }}"
                >
                    <mat-option *ngFor="let dropdownOption of dropdownFrequencyOptions" [value]="dropdownOption.value">
                        {{ dropdownOption.label }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="benefitDeductionFrequencyUuid.invalid">{{
                    benefitDeductionFrequencyUuid.errors | formErrors
                }}</mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{ 'payroll.benefits.benefitName' | translate | i18nLabel }}</mat-label>
                <input
                    matInput
                    type="text"
                    name="name"
                    required
                    #name="ngModel"
                    [(ngModel)]="benefit.name"
                    placeholder="{{ 'payroll.benefits.namePlaceholder' | translate }}"
                />
                <mat-error *ngIf="name.invalid">{{ name.errors | formErrors }}</mat-error>
            </mat-form-field>
            <ng-container *ngIf="!isNonCashTaxableBenefit(benefit.benefitTypeId)">
                <mat-form-field>
                    <mat-label>{{ 'payroll.benefits.glCodeExpense' | translate | i18nLabel }}</mat-label>
                    <input
                        matInput
                        type="text"
                        name="glCodeExpense"
                        #glCodeExpense="ngModel"
                        [(ngModel)]="benefit.glCodeExpense"
                        placeholder="1001001"
                    />
                    <mat-error *ngIf="glCodeExpense.invalid">{{ glCodeExpense.errors | formErrors }}</mat-error>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>{{ 'payroll.benefits.glCodePayable' | translate | i18nLabel }}</mat-label>
                    <input
                        matInput
                        type="text"
                        name="glCodePayable"
                        #glCodePayable="ngModel"
                        [(ngModel)]="benefit.glCodePayable"
                        placeholder="1001002"
                    />
                    <mat-error *ngIf="glCodePayable.invalid">{{ glCodePayable.errors | formErrors }}</mat-error>
                </mat-form-field>
            </ng-container>
        </div>
    </ng-container>
</form>
